module.exports = __webpack_public_path__ + "img/venue-3.5d743324.png";